// Angular
import { Injectable, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

// SyncFusion
import { GridComponent } from '@syncfusion/ej2-angular-grids';
import { MenuItem } from '@syncfusion/ej2-angular-navigations';

// Ui
import { CerPromptService } from '@cer/cer-ui/cer-ui-prompt.service';
import { UiCommandEvent } from '@ui/cer-ui-types';
import { uiCmdUpload } from '@ui/cer-ui-commands';

// Grid
import { CerGridCommandService } from './cer-grid-command.service';
import { CerGridEditService } from './cer-grid-edit.service';
import { CerDataImportClipboardService } from '@data/cer-data-excel-import/cer-data-import-clipboard.service';
import { CerGridComponent } from './cer-grid.component';
import { CerDataImportDialogService } from '@cer/cer-data/cer-data-excel-import/cer-data-import-dialog.service';

import { LinkedAttachmentDto } from '@app/api';
import { CerLinkedAttachmentUploadProgress, CerLinkedAttachmentUploader } from '@cer/cer-data/cer-linked-attachment/cer-linked-attachment-uploader';

@Injectable()
export class CerGridAttachmentService implements OnDestroy {
  // Subscriptions
  private subscriptionManager: Subscription = new Subscription();

  // Grid edit
  public appGrid: CerGridComponent;
  public grid: GridComponent;

  // Constructor
  constructor(
    private command: CerGridCommandService,
    private edit: CerGridEditService,
    private clipboardService: CerDataImportClipboardService,
    private importDialogService: CerDataImportDialogService,
    private ui: CerPromptService) {
    this.subscriptionManager.add(command.commandPre$.subscribe(cmd => this.onCommandPre(cmd)));
  }

  // Subscriptions
  ngOnDestroy(): void {
    this.subscriptionManager.unsubscribe();
  }

  public init(appGrid: CerGridComponent) {
    this.appGrid = appGrid;
    this.grid = appGrid.grid;
    //this.importService.init(appGrid);
  }

  public onCommandPre(event: UiCommandEvent) {
    switch (event.source) {
      case 'contextMenu':
        switch (event.actionType) {
          case 'contextMenuOpen':
            this.onContextMenuOpen(event);
            break;
        }
        break;
    }
    switch (event.commandId) {
      case uiCmdUpload.id:
        const v = event.formView?.viewMetadata;
        if (v?.attachmentUploadUrl == null) {
          this.ui.error('Vedhæftning understøttes ikke');
        }
        else {
          this.postUrl = v.attachmentUploadUrl(v, false);
          this.showUploadDialog(event.appComponent as CerGridComponent, uiCmdUpload.tooltipText);
        }

        break;
    }
  }

  // Clipboard
  private onContextMenuOpen(event: UiCommandEvent) {
    const menuItems: MenuItem[] = event.args.items as MenuItem[];
    const uploadItem = menuItems.find(i => i.id == uiCmdUpload.id);
    if (uploadItem) {
      const isVisible = this.command.contextMenuItemIsActive(uploadItem, event.args.rowInfo.target);
      if (isVisible) {
        const uploadVisible = this.edit.canAdd();
        this.command.contextMenuVisible(uploadItem, uploadVisible);
      }
    }
  }

  // Upload
  public async showUploadDialog(appGrid: CerGridComponent, title: string) {

    this.clipboardService.wireEvent();
    const icons = [
      '/assets/icons/pdf.svg',
      '/assets/icons/text.svg',
      '/assets/icons/word.svg',
      '/assets/icons/excel.svg',
      '/assets/icons/photo.svg',
      '/assets/icons/mail.svg'
    ];
    const dropEle = this.clipboardService.dropElementGet(icons, null);
    this.clipboardService.onFilesCallback = (fileList: FileList) => {
      this.uploadFiles(fileList);
    };
    const action = await this.importDialogService.dialogOpen(dropEle, title);
    if (action == 'reload') {
      //this.clipboardService.readClipboardItems(CerDataImportExcelReader.legalMimeTypes);
    }
    this.clipboardService.unwireEvent()
  }

  private postUrl: string;
  private async uploadFiles(fileList: FileList): Promise<number> {
    if (fileList == null || fileList.length == 0) {
      this.importDialogService.toast("Ingen filer angivet");
      return 0;
    }
    this.importDialogService.dialogHide();

    const formData = new FormData();
    var fileCount = 0;
    for (var i = 0; i < fileList.length; i++) {
      const file = fileList.item(i);
      if (file != null) {
        formData.append("file_" + i, file);
        fileCount++;
      }
    }

    const progress = new CerLinkedAttachmentUploadProgress(this.ui);

    try {

      await CerLinkedAttachmentUploader.uploadFormData(formData, this.postUrl, progress).then(content => {
        const dtos = JSON.parse(content) as LinkedAttachmentDto[];
        const g = this.appGrid;
        if (g != null) {
          (<any>g.grid.dataSource).dataSource.json = dtos;
          g.research();
        }

      })
        .catch(err => {
          var error = (typeof err === 'string' || err instanceof String)
            ? JSON.parse(err as string)
            : err;
          this.ui.operationEndError(error, "Fejl");

        });
    }
    catch (err: any) {
      var error = (typeof err === 'string' || err instanceof String)
        ? JSON.parse(err as string)
        : err;
      this.ui.operationEndError(error, "Fejl");
    }
    return fileCount;
  }
}
